<template>
  <div>
    <b-card>
      <h5>Tìm Kiếm:</h5>
      <div class="d-flex">
        <b-form-input
          style="width: 30%"
          type="search"
          v-model="searchText"
          @input="onInput"
          placeholder="Nhập tên người tạo cuộc họp... "
        ></b-form-input>

        <b-form-select
          @change="handleChangeSelectRoom"
          class="ml-4"
          style="width: 20%"
          v-model="roomSelected"
          :options="roomOptions"
        ></b-form-select>

        <b-form-select
          @change="handleChangeSelectStatus"
          class="ml-4"
          style="width: 20%"
          v-model="statusSelected"
          :options="statusOptions"
        ></b-form-select>
      </div>

      <b-tabs pills card>
        <CancelBookingModal :bookingInfo="bookingInfo" />

        <b-table striped hover :items="meetingList" :fields="visibleFilter">
          <template v-slot:cell(deleted)="row">
            <div class="text-center" v-if="row.item.deleted === false">
              còn hoạt động
            </div>
            <div class="text-center" v-else>đã xóa</div>
          </template>

          <template v-slot:cell(departmentId)="row">
            <div class="text-center">{{ row.item.departmentName }}</div>
          </template>

          <template v-slot:cell(date)="row">
            <div class="text-center">{{ row.item.date }}</div>
          </template>

          <template v-slot:cell(startingTime)="row">
            <div class="text-center">{{ row.item.startingTime }}</div>
          </template>

          <template v-slot:cell(endingTime)="row">
            <div class="text-center">{{ row.item.endingTime }}</div>
          </template>

          <template v-slot:cell(meetingContent)="row">
            <div class="text-center" v-if="row.item.meetingContent">
              {{
                row.item.meetingContent.length > 30
                  ? row.item.meetingContent.substring(0, 30) + "..."
                  : row.item.meetingContent
              }}
            </div>

            <div class="text-center" v-else>
              <p>không có tiêu đề</p>
            </div>
          </template>

          <template v-slot:cell(status)="row">
            <div class="text-center">
              <b-badge v-if="row.item.status === 'comingUp'" variant="primary"
                >Sắp diễn ra</b-badge
              >
              <b-badge v-if="row.item.status === 'done'" variant="success"
                >Đã xong</b-badge
              >
              <b-badge v-if="row.item.status === 'cancel'" variant="danger"
                >Đã Hủy</b-badge
              >
            </div>
          </template>

          <template v-slot:cell(seats)="row">
            <p class="text-center">{{ row.item.seats }}</p>
          </template>

          <template v-slot:cell(fullname)="row">
            <p :class="{ 'text-primary': row.item.userId === currentUser.id }">
              {{ row.item.fullname }}
            </p>
          </template>

          <template v-slot:cell(action)="row">
            <div class="d-flex align-items-center justify-content-center">
              <router-link :to="`/readMeetingDetails/${row.item.id}`">
                <div
                  class="mr-3 cursor_pointer"
                  v-b-tooltip.hover
                  title="Xem chi tiết"
                >
                  <i
                    class="fa fa-eye"
                    aria-hidden="true"
                    style="color: #8950fc"
                  ></i>
                </div>
              </router-link>
              <!--  btn xóa -->
              <div
                class="cursor_pointer"
                v-if="
                  (row.item.userId === currentUser.id &&
                    row.item.status === 'comingUp') ||
                  (currentUser.role === 'admin' &&
                    row.item.status === 'comingUp')
                "
              >
                <i
                  class="fa fa-trash text-danger"
                  v-b-modal:[`cancel-booking-modal-${row.item.id}`]
                  v-on:click="handleDeleted(row)"
                ></i>
              </div>
            </div>
          </template>
        </b-table>
        <!-- phan trang -->
        <b-pagination
          class="justify-content-end"
          @change="handldeChangeCurrentPage"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import CancelBookingModal from "../modals/CancelBookingModal.vue";
import debounce from "lodash/debounce";
import moment from "moment";
import ApiService from "@/core/services/api.service.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      meetingList: [],
      fields: [
        {
          key: "id",
          label: "ID",
          visible: false,
          thStyle: { textAlign: "center" },
        },
        {
          key: "meetingContent",
          label: "Tiêu Đề Cuộc Họp",
          visible: true,
          thStyle: { textAlign: "center" },
        },
        {
          key: "fullname",
          label: "Người Tạo Cuộc Họp",
          visible: true,
          thStyle: { textAlign: "center" },
        },
        {
          key: "date",
          label: "Ngày",
          visible: true,
          thStyle: { textAlign: "center" },
        },
        {
          key: "startingTime",
          label: "Bắt Đầu",
          visible: true,
          thStyle: { textAlign: "center" },
        },
        {
          key: "endingTime",
          label: "Kết Thúc",
          visible: true,
          thStyle: { textAlign: "center" },
        },
        {
          key: "departmentId",
          label: "Phòng Ban",
          visible: false,
          thStyle: { textAlign: "center" },
        },
        {
          key: "seats",
          label: "Số Người Tối Đa",
          visible: true,
          thStyle: { textAlign: "center" },
        },
        {
          key: "status",
          label: "Trạng Thái",
          visible: true,
          thStyle: { textAlign: "center" },
        },
        {
          key: "action",
          label: "Thao Tác",
          visible: true,
          thStyle: { textAlign: "center" },
        },
      ],
      bookingInfo: null,
      searchText: "",
      roomSelected: 1,
      statusSelected: "comingUp",
      roomOptions: [],
      statusOptions: [
        { value: "comingUp", text: "Sắp diễn ra" },
        { value: "done", text: "Đã xong" },
        { value: "cancel", text: "Đã hủy" },
      ],
      currentPage: 1,
      rows: 0,
      perPage: 7,
      isValid: false,
    };
  },
  props: {
    activeTab: {
      type: Number,
    },
  },
  methods: {
    handleDeleted(row) {
      const newItems = { ...row.item };
      this.bookingInfo = newItems;
    },
    async listOfAdminsPresent(currentPage) {
      await ApiService.query("/bookinginfo/getListOfMeetingYouAttend", {
        params: {
          roomId: parseInt(this.roomSelected),
          status: this.statusSelected,
          page: currentPage || this.currentPage,
          pageSize: this.perPage,
          role: this.currentUser.role,
          userId: parseInt(this.currentUser.id),
        },
      }).then((db) => {
        const { data } = db.data.data;

        if (this.currentUser.role === "admin") {
          const newData = data.map((item) => {
            return {
              ...item,
              id: item.bookingId,
              userId: item["booking.userId"],
              email: item["booking.user.email"],
              endingTime: moment(item["booking.endingTime"]).format("HH:mm"),
              startingTime: moment(item["booking.startingTime"]).format(
                "HH:mm"
              ),
              fulldate: item.startingTime,
              date: moment(item["booking.startingTime"]).format("DD/MM/YYYY"),
              departmentName: item["booking.department.departmentName"],
              seats: item["booking.room.seats"],
              roomName: item["booking.room.roomName"],
              meetingContent: item["booking.meetingContent"],
              status: item["booking.status"],
              fullname: item["booking.user.fullname"],
            };
          });
          this.meetingList = newData;
          this.rows = db.data.data.count;
        }
      });
    },
    async search(currentPage) {
      let response = await ApiService.query(
        `/bookinginfo/searchBookinginfoAdmin`,
        {
          params: {
            fullname: this.searchText,
            roomId: parseInt(this.roomSelected),
            pageSize: this.perPage,
            status: this.statusSelected,
            userId: parseInt(this.currentUser.id),
            page: currentPage || this.currentPage,
            role: this.currentUser.role,
          },
        }
      );

      if (this.currentUser.role === "admin") {
        const searchValue = response.data.data.data.map((item) => {
          return {
            ...item,
            id: item.bookingId,
            userId: item["booking.userId"],
            fullname: item["booking.user.fullname"],
            endingTime: moment(item["booking.endingTime"]).format("HH:mm"),
            startingTime: moment(item["booking.startingTime"]).format("HH:mm"),
            date: moment(item["booking.startingTime"]).format("DD/MM/YYYY"),
            departmentName: item["booking.department.departmentName"],
            seats: item["booking.room.seats"],
            roomName: item["booking.room.roomName"],
            meetingContent: item["booking.meetingContent"],
            status: item["booking.status"],
          };
        });

        if (this.searchText.length === 0) {
          this.listOfAdminsPresent();
        } else {
          this.meetingList = searchValue;
          this.rows = response.data.data.count;
        }
      }
    },
    onInput: debounce(function () {
      this.search();
    }, 500),

    async getRoomList() {
      await ApiService.get("/room/getAllOfRoom").then((db) => {
        const { data } = db.data;
        const newData = data.map((item) => {
          return {
            value: item.id,
            text: item.roomName,
          };
        });
        this.roomOptions = [...newData];
      });
    },
    handleChangeSelectRoom() {
      if (this.searchText.length > 0) {
        this.search();
      } else {
        this.listOfAdminsPresent();
      }
    },
    handleChangeSelectStatus() {
      if (this.searchText.length > 0) {
        this.search();
      } else {
        this.listOfAdminsPresent();
      }
    },
    handldeChangeCurrentPage(value) {
      this.currentPage = value;
      if (this.searchText.length > 0) {
        this.search(value);
      } else {
        this.listOfAdminsPresent();
      }
    },
  },
  computed: {
    ...mapGetters(["currentUser", "reloadCount"]),
    visibleFilter() {
      return this.fields.filter((item) => item.visible === true);
    },
  },
  watch: {
    reloadCount: {
      handler() {
        this.listOfAdminsPresent();
      },
    },
  },
  components: {
    CancelBookingModal,
  },
  mounted() {
    this.listOfAdminsPresent();
    this.getRoomList();
    this.handldeChangeCurrentPage();
    moment.locale("vi");
  },
};
</script>
<style scope>
.tooltip {
  opacity: 1;
}
</style>
